import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  SearchForm,
  SearchFormProps,
  TableContainer,
  TableHeader,
  Typography,
} from '@occc-app/design-system';
import { useGetGamesList } from '@occc-app/dataAccessLayer/game/queries';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useSearchParams } from '@occc-app/hooks/useSearchParams';
import { useChainId } from '@occc-app/Chain/hooks';
import { Offer_Engagement_Type } from '@occc/graphql';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { GameTable } from './GameTable';

export const GameTableContainer = () => {
  const navigate = useNavigate();
  const chainId = useChainId();

  const [search, setSearch] = useSearchParams();
  const [paginationInfo, onPageChange] = usePaginationParams();
  const isUserPermittedToEditGame = useIsUserPermittedTo(Feature.GAME_EDIT);

  const { loading, error, data, paginationProps } = useGetGamesList({
    filter: {
      chainIdEquals: chainId,
      search,
      engagementTypeIncludes: [Offer_Engagement_Type.GameVoucher],
    },
    paginationInfo,
    onPageChange,
  });

  const onRowClick = useCallback((id: string) => navigate(id), [navigate]);

  const onSearch: SearchFormProps['onSubmit'] = ({ search }) => {
    setSearch(search);
  };

  return (
    <TableContainer>
      <TableHeader
        title={
          <Typography variant='h6' component='h3'>
            Vouchered Games
          </Typography>
        }
        disableTitleTypography
        actions={<SearchForm onSubmit={onSearch} initialValues={{ search }} />}
      />
      <GameTable
        offers={data}
        loading={loading}
        error={error}
        paginationProps={paginationProps}
        areActionsVisible={isUserPermittedToEditGame}
        onRowClick={onRowClick}
      />
    </TableContainer>
  );
};
